import { CheckIcon } from "@heroicons/react/24/outline"
import { useEffect } from "react"

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ResumenPagos = ({ showPagar = false, opcion, completarDisabled = false, handleQuitarCargo, selectedCargos = [], handleTotal, handleValidar, showFormPagos, alumnoSeleccionado, esColegiatura, esPlan4 = false, handlePlan4, setEtapaPago, etapaPago=false }) => {
//console.log("alumnoSeleccionado: ",alumnoSeleccionado)
//console.log("cargos: ",selectedCargos)

useEffect(() => {
  //setEtapaPago(()=> false)
}, [])

    return (
        <div className='px-8'>
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none bg-secundarioMira">
                <h1 className="py-2 text-center text-2xl font-bold tracking-tight text-white">Resumen de pagos</h1>
                <section aria-labelledby="cart-heading">
                    <h2 id="cart-heading" className="sr-only">
                        Items in your shopping cart
                    </h2>

                    <ul role="list" className="divide-y divide-gray-200 border-b border-t border-grisMira">
                        {selectedCargos.map((product, iDx) => {
                            return (
                                <li key={iDx} className="flex py-4">
                                    <div className="ml-4 flex flex-1 flex-col sm:ml-6">
                                        <div>
                                            <div className="flex justify-between">
                                                <h4 className="text-base font-medium text-white hover:text-grisMira">
                                                    {product.Descrip}
                                                </h4>
                                                <p className="px-4 ml-4 text-base font-medium text-secundario">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(product.Saldo || product.Valor || 0)}</p>
                                            </div>
                                            <p className="mt-1 text-base text-grisMira font-semibold">{esColegiatura? product.Carnet: product.Materia}</p>
                                            <p className="mt-1 text-base text-grisMira font-semibold">{esColegiatura? product.Alumno || alumnoSeleccionado.NombreCompleto : product.Alumno || alumnoSeleccionado.NombreCompleto }</p>
                                        </div>

                                        <div className="mt-1 flex flex-1 items-end justify-between">
                                            <p className="flex items-center space-x-2 text-sm text-white">
                                                <CheckIcon className="h-5 w-5 flex-shrink-0 text-green-500" aria-hidden="true" />
                                                <span>Agregada</span>
                                            </p>
                                            {!showFormPagos &&
                                                <div className="ml-4 px-4">
                                                    {!showPagar && 
                                                    <button type="button"
                                                    onClick={() => handleQuitarCargo(iDx, product.Carnet)}
                                                    className="text-base font-medium text-azulBrillanteMira hover:text-secundario">
                                                        <span>Quitar cargo</span>
                                                    </button>
                                                        }
                                                </div>}
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </section>

                {/* Order summary */}
                <section aria-labelledby="summary-heading" className="mt-2" >
                    <h2 id="summary-heading" className="sr-only">
                        Order summary
                    </h2>

                    <div>
                        <dl className="space-y-4">
                            <div className="py-2 flex items-center justify-between">
                                <dt className="px-4 text-base font-medium text-white">Total a pagar</dt>
                                <dd className="px-4 ml-4 text-lg font-medium text-mostazaMira">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(handleTotal())}</dd>
                            </div>
                        </dl>
                    </div>

                    {!showFormPagos
                        ? <div className="mt-4">
                            {etapaPago?<></>:
                            <button
                            disabled={completarDisabled}
                            //disabled={handleTotal() === 0  || completarDisabled}
                            onClick={() => esPlan4?handlePlan4( opcion ):handleValidar(false)}
                            className={classNames(!completarDisabled
                                ? 'hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2'
                                : 'bg-grisMira',
                                'w-full rounded-md px-4 py-3 text-base font-medium text-white border border-transparent bg-azulBrillanteMira shadow-sm')}
                                >
                                Completar pago
                            </button>
                            }
                        </div>
                        : <div className="mt-4" />
                    }

                </section>
            </div>
        </div>
    )
}

export default ResumenPagos